import GetAnalyticsForMyOrganisationRequestModelBase from '../_generated/modelBases/get-analytics-for-my-organisation-request-model-base';

export default class GetAnalyticsForMyOrganisationRequestModel extends GetAnalyticsForMyOrganisationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
